const getEnvValue = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmedValue = value.trim()
  return trimmedValue || undefined
}

const whmcsRoot = getEnvValue(process.env.WHMCS_ROOT) ?? '/cloud'
const normalizedWhmcsRoot = whmcsRoot.replace(/\/+$/, '')
export const WHMCS_ROOT: string =
  normalizedWhmcsRoot === '' ||
  /^https?:\/\//i.test(normalizedWhmcsRoot) ||
  normalizedWhmcsRoot.startsWith('/')
    ? normalizedWhmcsRoot
    : `/${normalizedWhmcsRoot}`

const newApiEndpoint = getEnvValue(process.env.WHMCS_NEW_API)
const rawApiEndpoint: string =
  newApiEndpoint ??
  getEnvValue(process.env.WHMCS_API) ??
  `${WHMCS_ROOT}/custom/api.php`

const normalizedApiEndpoint = rawApiEndpoint.replace(/\/+$/, '')
const [apiBaseEndpoint, apiQuery] = normalizedApiEndpoint.split('?', 2)
const normalizedApiBaseEndpoint = apiBaseEndpoint.replace(/\/api\.php$/, '/api')
export const API_ENDPOINT: string = newApiEndpoint
  ? `${normalizedApiBaseEndpoint}${apiQuery ? `?${apiQuery}` : ''}`
  : normalizedApiEndpoint

export const apiEndpointAction = (action: string, pathFallback: string = action): string => {
  const [rawBaseEndpoint, rawQuery] = API_ENDPOINT.split('?', 2)
  const baseEndpoint = rawBaseEndpoint.replace(/\/+$/, '')

  if (baseEndpoint.endsWith('/api')) {
    const path = pathFallback.replace(/^\/+/, '')
    return `${baseEndpoint}/${path}${rawQuery ? `?${rawQuery}` : ''}`
  }

  return `${baseEndpoint}?${rawQuery ? `${rawQuery}&` : ''}action=${encodeURIComponent(action)}`
}

const appendRoot = (url: string) => {
  const normalizedPath = url.startsWith('/') ? url : `/${url}`
  return `${WHMCS_ROOT}${normalizedPath}`
}

export const URL_CONF_PRODUCT = appendRoot('/cart.php?a=confproduct')
export const URL_ADD_PRODUCT = appendRoot('/cart.php?a=add')
export const URL_ADD_PRODUCT_WITH_DOMAIN = appendRoot(
  '/cart.php?a=add&domainselect=1'
)
export const URL_UPDATE_DOMAIN_PERIOD = appendRoot(
  '/cart.php?a=updateDomainPeriod'
)
export const URL_CONF_DOMAIN = appendRoot('/cart.php?a=confdomains')
